import api from 'utils/apiClient';

export const getPlainLanguages = () => {
  return api.get('/languages', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 100,
    },
  });
};

export const createLanguage = (data) => {
  return api.post('/languages', data);
};

export const editLanguage = (id, data) => {
  return api.patch(`/languages/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    notification: {
      visible: false,
    },
  });
};

export const deleteLanguage = (id) => {
  return api.delete(`/languages/${id}`);
};

export const getTranslations = (params) => {
  return api.get('/translations', { params });
};

export const editTranslations = (id, data) => {
  return api.patch(`/translations/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    notification: {
      visible: false,
    },
  });
};

export const addTranslations = (data) => {
  return api.post('/translations', data);
};

export const clearTranslations = (id) => {
  return api.delete(`/translations/${id}`);
};

export const importTranslations = () => {
  return api.post('/translation_imports');
}

export const getImportTranslationsStatus = (id) => {
  return api.get(`/translation_imports/${id}`);
}